module.exports = __webpack_public_path__ + "img/paypal.cea6573b.svg";